import { useAuthStore } from '../store/authStore';

/** Returns helpers bound to the current user's permissions. */
export function usePermission() {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const hasAnyPermission = useAuthStore((s) => s.hasAnyPermission);
  return { hasPermission, hasAnyPermission };
}
